import { render, staticRenderFns } from "./BicGroupPage.vue?vue&type=template&id=e7cc572e&"
import script from "./BicGroupPage.vue?vue&type=script&lang=js&"
export * from "./BicGroupPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7cc572e')) {
      api.createRecord('e7cc572e', component.options)
    } else {
      api.reload('e7cc572e', component.options)
    }
    module.hot.accept("./BicGroupPage.vue?vue&type=template&id=e7cc572e&", function () {
      api.rerender('e7cc572e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bic/BicGroupPage.vue"
export default component.exports